import { getNotificationState, getIconType } from 'common/header/notifications/hooks/mappers/impl/shared';
import type { MappedNotification, Notification } from 'common/header/notifications/Notifications.types';
import { formatDistance } from 'date-fns';

export function coreMapper(notification: Notification): MappedNotification {
  return {
    ...notification,
    type: notification.type,
    date: formatDistance(new Date(notification.statusModified), new Date()) as string,
    iconType: getIconType(getNotificationState(notification.status)),
    description: '',
    to: undefined,
    title: ''
  };
}
